export default "__VITE_ASSET__eGeLNhE$__"